import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-read-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-bold font-heading text-background-50">韩国漫画网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed mb-4">
              您的一站式韩漫在线阅读平台，提供高质量、高清晰度的韩国漫画资源，免费畅享海量优质内容。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-wechat-line text-background-200"></i>
                </div>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-weibo-line text-background-200"></i>
                </div>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-qq-line text-background-200"></i>
                </div>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              <a href="#quick-links" className="cursor-pointer">快捷链接</a>
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">用户协议</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a></li>
              <li><a href="#" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">版权声明</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
              <a href="#categories" className="cursor-pointer">热门分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">{cat.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">订阅更新</h4>
            <p className="text-sm text-background-400 mb-4 leading-relaxed">订阅我们的更新通知，第一时间获取最新漫画上架信息！</p>
            <form onSubmit={handleSubscribe} className="flex gap-2">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入您的邮箱"
                className="flex-1 px-4 py-2.5 rounded-lg text-sm bg-background-800 text-background-50 placeholder:text-background-500 border border-background-700 focus:border-primary-400 outline-none transition-colors"
                required
              />
              <button type="submit" className="px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                {subscribed ? '已订阅 ✓' : '订阅'}
              </button>
            </form>
          </div>
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">© 2026 韩国漫画网. All rights reserved. 本站所有漫画资源均来自网络，仅供学习交流使用。</p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer" rel="nofollow">友情链接</a>
          </div>
        </div>
      </div>
    </footer>
  );
}